module.exports = __webpack_public_path__ + "media/images/dashcore/bg/wedding-back-c9facb20316d5701e2ad7ff3b2569daa.jpg";